import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.reviews');
import { OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-reviews',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.reviews/view.scss */
/* src/app/page.reviews/view.scss: no such file or directory */`],
})
export class PageReviewsComponent implements OnInit, OnDestroy {
    public projects: any[] = [];
    public reviews: any[] = [];
    public projectOptions: any[] = [];
    public reviewTotal: number = 0;
    public loading: boolean = true;
    public filters: any = { text: '', label: '', project_id: '' };
    public tagFilterOpen: boolean = false;
    public tagFilterQuery: string = '';
    public projectFilterOpen: boolean = false;
    public projectFilterQuery: string = '';
    public projectOptionsScope: string = '';
    public projectOptionsLoading: boolean = false;
    public projectOptionsLoadingScope: string = '';
    public projectPage: number = 1;
    public projectPageSize: number = 10;
    public reviewPage: number = 1;
    public reviewPageSize: number = 12;
    public projectStatusFilter: string = 'active';
    public reviewCategoryFilter: string = '';
    public projectTypeFilter: string = 'all';
    public codexStatusFilter: string = 'all';
    public projectStatusCounts: any = { active: 0, archived: 0, disabled: 0 };
    public reviewStatusCounts: any = { open: 0, in_progress: 0, in_review: 0, resolved: 0, recheck: 0, closed: 0 };
    public selectedReview: any = null;
    public reviewDetailLoading: boolean = false;
    public reviewModalTab: string = 'info';
    public reviewLogTab: string = 'navigation';
    public sendingActivity: boolean = false;
    public activityForm: any = { message: '', status: '' };
    public codexStatusPollTimer: any = null;
    public codexStatusPollIntervalMs: number = 30000;
    public destroyed: boolean = false;
    public projectStatusOptions: any[] = [
        { value: 'active', label: '활성' },
        { value: 'archived', label: '보관' },
        { value: 'disabled', label: '비활성' }
    ];
    public reviewStatusOptions: any[] = [
        { value: '', label: '전체' },
        { value: 'open', label: '열림' },
        { value: 'in_progress', label: '진행' },
        { value: 'in_review', label: '검토' },
        { value: 'resolved', label: '해결' },
        { value: 'recheck', label: '재검토' },
        { value: 'closed', label: '닫힘' }
    ];
    public reviewCategoryOptions: any[] = [
        { value: '', label: '전체' },
        { value: 'bug', label: '버그' },
        { value: 'ux', label: 'UX' },
        { value: 'design', label: '설계' },
        { value: 'content', label: '콘텐츠' },
        { value: 'performance', label: '성능' },
        { value: 'accessibility', label: '접근성' },
        { value: 'security', label: '보안' },
        { value: 'structure', label: '구조' },
        { value: 'data', label: '데이터' },
        { value: 'message', label: '메시지' },
        { value: 'typo', label: '오탈자' },
        { value: 'other', label: '기타' }
    ];
    public projectTypeFilterOptions: any[] = [
        { value: 'all', label: '전체' },
        { value: 'pdf', label: 'PDF' },
        { value: 'html', label: 'HTML' },
        { value: 'web_service', label: '웹서비스' },
    ];
    public codexStatusFilterOptions: any[] = [
        { value: 'all', label: '에이전트 전체' },
        { value: 'enabled', label: '에이전트 활성' },
        { value: 'disabled', label: '에이전트 비활성' }
    ];
    public reviewLogTabs: any[] = [
        { key: 'navigation', label: '네비게이션', field: 'navigation_log' },
        { key: 'input', label: '입력', field: 'input_log' },
        { key: 'network', label: '트래픽', field: 'network_log' },
        { key: 'console', label: '콘솔', field: 'console_log' },
        { key: 'fingerprint', label: '환경', field: 'fingerprint_log' }
    ];
    public loadedScope: string = '';
    private routeSubscription: any = null;
    private workspaceDetached: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  public router: Router) { }

    public async ngOnInit() {
        this.destroyed = false;
        await this.service.init();
        await this.service.auth.allow('/login');
        this.routeSubscription = this.router.events.subscribe(async (event: any) => {
            if (event instanceof NavigationEnd) {
                await this.handleRouteScopeChange(event.urlAfterRedirects || event.url || location.pathname);
            }
        });
        await this.load();
    }

    public ngOnDestroy() {
        this.destroyed = true;
        if (this.routeSubscription && this.routeSubscription.unsubscribe) this.routeSubscription.unsubscribe();
        this.routeSubscription = null;
        this.clearCodexStatusPoll();
    }

    public reviewopsWorkspaceDetached() {
        this.workspaceDetached = true;
        this.clearCodexStatusPoll();
    }

    public reviewopsWorkspaceAttached() {
        const wasDetached = this.workspaceDetached;
        this.workspaceDetached = false;
        if (!wasDetached || this.destroyed) return;
        this.scheduleCodexStatusPoll(false);
    }

    public async refreshCurrentScope() {
        if (this.loading) return;
        await this.load(this.scope());
    }

    public scopeFromPath(path: string = location.pathname) {
        const cleanPath = String(path || '').split('?')[0];
        if (cleanPath.indexOf('/reviews/managed') === 0) return 'managed';
        if (cleanPath.indexOf('/reviews/authored-review') === 0) return 'authored-review';
        if (cleanPath.indexOf('/reviews/authored-closed') === 0) return 'authored-closed';
        if (cleanPath.indexOf('/reviews/authored') === 0) return 'authored';
        if (cleanPath.indexOf('/reviews/task-new') === 0) return 'task-new';
        if (cleanPath.indexOf('/reviews/task-active') === 0) return 'task-active';
        if (cleanPath.indexOf('/reviews/task-review') === 0) return 'task-review';
        if (cleanPath.indexOf('/reviews/task-closed') === 0) return 'task-closed';
        if (cleanPath.indexOf('/reviews/todo') === 0) return 'todo';
        return 'participating';
    }

    public scope() {
        return this.scopeFromPath();
    }

    public async handleRouteScopeChange(path: string = location.pathname) {
        if (this.workspaceDetached) return;
        const nextScope = this.scopeFromPath(path);
        if (!this.loadedScope) {
            this.loadedScope = nextScope;
            return;
        }
        if (nextScope === this.loadedScope) {
            await this.service.render();
            return;
        }

        this.loadedScope = nextScope;
        this.resetProjectPagination();
        this.resetReviewPagination();
        this.clearReviewProjectFilterState();
        this.projectOptions = [];
        this.projectOptionsScope = '';
        await this.load(nextScope);
    }

    public isManagedScope() {
        return this.scope() === 'managed';
    }

    public isProjectScope() {
        const scope = this.scope();
        return scope === 'managed' || scope === 'participating';
    }

    public projectTableColspan() {
        return this.isManagedScope() ? 5 : 4;
    }

    public isReviewScope() {
        return !this.isProjectScope();
    }

    public isReviewScopeName(scope: string = this.scope()) {
        return scope !== 'managed' && scope !== 'participating';
    }

    public isAuthoredScope() {
        return this.scope().indexOf('authored') === 0;
    }

    public reviewScopeStatuses(scope: string = this.scope()) {
        const statusMap: any = {
            authored: ['open', 'in_progress', 'in_review', 'recheck'],
            'authored-review': ['resolved'],
            'authored-closed': ['closed'],
            todo: ['open', 'in_progress', 'in_review', 'resolved', 'recheck'],
            'task-new': ['open'],
            'task-active': ['in_progress', 'in_review', 'recheck'],
            'task-review': ['resolved'],
            'task-closed': ['closed']
        };
        return statusMap[scope] || [];
    }

    public reviewPeopleColumnLabel() {
        return this.isAuthoredScope() ? '관리자' : '작성자';
    }

    public pageTitle() {
        const scope = this.scope();
        if (scope === 'managed') return '관리 프로젝트';
        if (scope === 'participating') return '참여 프로젝트';
        if (scope === 'authored') return '내 리뷰 현황';
        if (scope === 'authored-review') return '리뷰 검토';
        if (scope === 'authored-closed') return '종결된 리뷰';
        if (scope === 'task-new') return '신규 작업';
        if (scope === 'task-active') return '진행중 작업';
        if (scope === 'task-review') return '검증 대기 작업';
        if (scope === 'task-closed') return '완료 작업';
        if (scope === 'todo') return '할일 리뷰';
        return '리뷰';
    }

    public pageDescription() {
        const scope = this.scope();
        if (scope === 'managed') return '프로젝트 관리자로 지정된 프로젝트를 모아봅니다.';
        if (scope === 'participating') return '리뷰어로 참여 중인 그룹의 프로젝트를 모아봅니다.';
        if (scope === 'authored') return '내가 작성한 열림, 진행, 검토, 재검토 상태 리뷰입니다.';
        if (scope === 'authored-review') return '내가 작성한 해결 상태 리뷰입니다.';
        if (scope === 'authored-closed') return '내가 작성한 닫힘 상태 리뷰입니다.';
        if (scope === 'task-new') return '내가 관리자로 지정된 프로젝트의 열림 상태 리뷰입니다.';
        if (scope === 'task-active') return '내가 관리자로 지정된 프로젝트의 진행, 검토, 재검토 상태 리뷰입니다.';
        if (scope === 'task-review') return '내가 관리자로 지정된 프로젝트의 해결 상태 리뷰입니다.';
        if (scope === 'task-closed') return '내가 관리자로 지정된 프로젝트의 닫힘 상태 리뷰입니다.';
        if (scope === 'todo') return '내가 관리하는 프로젝트의 닫히지 않은 리뷰입니다.';
        return '';
    }

    public currentListPath() {
        return `/reviews/${this.scope()}`;
    }

    public loadParams(scope: string = this.scope()) {
        const reviewScope = scope !== 'managed' && scope !== 'participating';
        return {
            scope,
            text: reviewScope ? '' : (this.filters.text || ''),
            label: reviewScope ? '' : (this.filters.label || ''),
            project_id: reviewScope ? (this.filters.project_id || '') : '',
            category: reviewScope ? (this.reviewCategoryFilter || '') : '',
            page: reviewScope ? this.reviewPage : 1,
            page_size: reviewScope ? this.reviewPageSize : this.projectPageSize,
            include_project_options: '0'
        };
    }

    public async load(scope: string = this.scope()) {
        this.loadedScope = scope;
        this.loading = true;
        this.projects = [];
        this.reviews = [];
        this.reviewTotal = 0;
        this.calculateProjectStatusCounts();
        this.calculateReviewStatusCounts();
        await this.service.render();

        const { code, data } = await wiz.call('load', this.loadParams(scope));
        if (code === 200) {
            this.projects = data.projects || [];
            this.reviews = data.reviews || [];
            if (Array.isArray(data.project_options)) {
                this.projectOptions = data.project_options || [];
                this.projectOptionsScope = scope;
            }
            if (this.isProjectScope()) {
                this.projectOptions = [];
                this.projectOptionsScope = '';
                this.calculateProjectStatusCounts();
                this.ensureProjectPage();
                this.clearCodexStatusPoll();
            } else {
                this.reviewTotal = Number(data.review_total || 0);
                this.reviewPage = Number(data.review_page || this.reviewPage || 1);
                this.reviewPageSize = Number(data.review_page_size || this.reviewPageSize || 12);
                this.ensureReviewProjectFilterOption();
                this.calculateReviewStatusCounts();
                this.ensureReviewPage();
                this.scheduleCodexStatusPoll();
                this.ensureReviewProjectOptions(scope);
            }
        } else {
            await this.service.modal.error(data.message || '목록을 불러오지 못했습니다.');
        }

        this.loading = false;
        await this.service.render();
    }

    public async loadReviewProjectOptions(scope: string = this.scope()) {
        if (!this.isReviewScopeName(scope)) return;
        if (this.projectOptionsLoading && this.projectOptionsLoadingScope === scope) return;
        this.projectOptionsLoading = true;
        this.projectOptionsLoadingScope = scope;
        try {
            const { code, data } = await wiz.call('load_project_options', { scope });
            if (code === 200 && scope === this.scope()) {
                this.projectOptions = data.project_options || [];
                this.projectOptionsScope = scope;
                this.ensureReviewProjectFilterOption();
                await this.service.render();
            }
        } catch (e) {
        } finally {
            if (this.projectOptionsLoadingScope === scope) {
                this.projectOptionsLoading = false;
                this.projectOptionsLoadingScope = '';
            }
        }
    }

    public ensureReviewProjectOptions(scope: string = this.scope()) {
        if (!this.isReviewScopeName(scope)) return;
        if (this.projectOptionsScope === scope) return;
        this.loadReviewProjectOptions(scope);
    }

    public calculateProjectStatusCounts() {
        const counts: any = { active: 0, archived: 0, disabled: 0 };
        for (const project of this.projects) {
            const status = project && project.status ? project.status : 'active';
            if (counts[status] === undefined) counts[status] = 0;
            counts[status] += 1;
        }
        this.projectStatusCounts = counts;
    }

    public calculateReviewStatusCounts() {
        const counts: any = { open: 0, in_progress: 0, in_review: 0, resolved: 0, recheck: 0, closed: 0 };
        for (const review of this.reviews) {
            const status = review && review.status ? review.status : 'open';
            if (counts[status] === undefined) counts[status] = 0;
            counts[status] += 1;
        }
        this.reviewStatusCounts = counts;
    }

    public async setProjectStatusFilter(value: string) {
        this.projectStatusFilter = value || 'active';
        this.resetProjectPagination();
        await this.service.render();
    }

    public async setProjectTypeFilter(value: string) {
        this.projectTypeFilter = value || 'all';
        this.resetProjectPagination();
        await this.service.render();
    }

    public async setCodexStatusFilter(value: string) {
        this.codexStatusFilter = value || 'all';
        this.resetProjectPagination();
        await this.service.render();
    }

    public async setReviewCategoryFilter(value: string) {
        this.reviewCategoryFilter = value || '';
        this.resetReviewPagination();
        await this.load();
    }

    public async searchProjects() {
        if (this.isReviewScope()) {
            this.resetReviewPagination();
        } else {
            this.resetProjectPagination();
        }
        await this.load();
    }

    public filteredProjects() {
        const label = String(this.filters.label || '').trim().toLowerCase();
        const type = this.projectTypeFilter || 'all';
        const codexStatus = this.isManagedScope() ? (this.codexStatusFilter || 'all') : 'all';
        return this.projects.filter((project) => {
            if ((project && project.status ? project.status : 'active') !== this.projectStatusFilter) return false;
            if (type !== 'all' && this.projectTypeValue(project) !== type) return false;
            if (codexStatus === 'enabled' && !this.isCodexEnabled(project)) return false;
            if (codexStatus === 'disabled' && this.isCodexEnabled(project)) return false;
            if (label && !this.projectLabels(project).some((item) => item.toLowerCase() === label)) return false;
            return true;
        });
    }

    public visibleProjects() {
        const rows = this.filteredProjects();
        const start = (this.projectPage - 1) * this.projectPageSize;
        return rows.slice(start, start + this.projectPageSize);
    }

    public projectTotalCount() {
        return this.filteredProjects().length;
    }

    public projectTotalPages() {
        const total = Math.ceil(this.projectTotalCount() / this.projectPageSize);
        return Math.max(total || 1, 1);
    }

    public projectPageStart() {
        const total = this.projectTotalCount();
        if (!total) return 0;
        return (this.projectPage - 1) * this.projectPageSize + 1;
    }

    public projectPageEnd() {
        return Math.min(this.projectPage * this.projectPageSize, this.projectTotalCount());
    }

    public projectPageNumbers() {
        const total = this.projectTotalPages();
        const current = Math.min(Math.max(this.projectPage, 1), total);
        const start = Math.max(1, Math.min(current - 2, total - 4));
        const end = Math.min(total, start + 4);
        const pages: number[] = [];
        for (let page = start; page <= end; page++) pages.push(page);
        return pages;
    }

    public setProjectPage(page: number) {
        const total = this.projectTotalPages();
        const next = Math.min(Math.max(Number(page) || 1, 1), total);
        if (this.projectPage === next) return;
        this.projectPage = next;
        this.service.render();
    }

    public resetProjectPagination() {
        this.projectPage = 1;
    }

    public ensureProjectPage() {
        this.setProjectPage(this.projectPage);
    }

    public filteredReviews() {
        const statuses = this.reviewScopeStatuses();
        const category = this.reviewCategoryFilter || '';
        return this.reviews.filter((review) => {
            const reviewStatus = review && review.status ? review.status : 'open';
            if (statuses.length && !statuses.includes(reviewStatus)) return false;
            if (category && (review && review.category ? review.category : 'other') !== category) return false;
            return true;
        });
    }

    public reviewProjectOptions() {
        return (this.projectOptions || []).filter((project) => project && project.id);
    }

    public selectedReviewProjectOption() {
        const projectId = String(this.filters.project_id || '');
        if (!projectId) return null;
        return this.reviewProjectOptions().find((project) => project.id === projectId) || null;
    }

    public reviewProjectFilterText(project: any) {
        const name = project && project.name ? project.name : '프로젝트';
        const group = project && project.group && project.group.name ? project.group.name : '';
        return group ? `${name} · ${group}` : name;
    }

    public filteredReviewProjectOptions() {
        const query = String(this.projectFilterQuery || '').trim().toLowerCase();
        return this.reviewProjectOptions().filter((project) => {
            const haystack = [
                project && project.name ? project.name : '',
                project && project.group && project.group.name ? project.group.name : '',
                project && project.group && project.group.description ? project.group.description : ''
            ].join(' ').toLowerCase();
            return !query || haystack.includes(query);
        });
    }

    public openReviewProjectFilter() {
        if (!this.isReviewScope()) return;
        this.projectFilterOpen = true;
        this.service.render();
    }

    public closeReviewProjectFilterLater() {
        window.setTimeout(async () => {
            this.projectFilterOpen = false;
            const selected = this.selectedReviewProjectOption();
            this.projectFilterQuery = selected ? this.reviewProjectFilterText(selected) : '';
            await this.service.render();
        }, 120);
    }

    public async selectReviewProjectFilter(project: any) {
        if (!project || !project.id) return;
        this.filters.project_id = project.id;
        this.projectFilterQuery = this.reviewProjectFilterText(project);
        this.projectFilterOpen = false;
        this.resetReviewPagination();
        await this.load();
    }

    public async selectFirstReviewProjectFilter() {
        const options = this.filteredReviewProjectOptions();
        if (options.length) await this.selectReviewProjectFilter(options[0]);
    }

    public clearReviewProjectFilterState() {
        this.filters.project_id = '';
        this.projectFilterQuery = '';
        this.projectFilterOpen = false;
    }

    public async clearReviewProjectFilter() {
        this.clearReviewProjectFilterState();
        this.resetReviewPagination();
        await this.load();
    }

    public ensureReviewProjectFilterOption() {
        const selected = this.selectedReviewProjectOption();
        if (this.filters.project_id && !selected) {
            if (this.projectOptionsLoading || !this.projectOptions.length) return;
            this.clearReviewProjectFilterState();
            return;
        }
        this.projectFilterQuery = selected ? this.reviewProjectFilterText(selected) : '';
    }

    public visibleReviews() {
        return this.filteredReviews();
    }

    public reviewTotalCount() {
        return this.isReviewScope() ? this.reviewTotal : this.filteredReviews().length;
    }

    public reviewTotalPages() {
        const total = Math.ceil(this.reviewTotalCount() / this.reviewPageSize);
        return Math.max(total || 1, 1);
    }

    public reviewPageStart() {
        const total = this.reviewTotalCount();
        if (!total) return 0;
        return (this.reviewPage - 1) * this.reviewPageSize + 1;
    }

    public reviewPageEnd() {
        const loaded = this.filteredReviews().length;
        return Math.min((this.reviewPage - 1) * this.reviewPageSize + loaded, this.reviewTotalCount());
    }

    public reviewPageNumbers() {
        const total = this.reviewTotalPages();
        const current = Math.min(Math.max(this.reviewPage, 1), total);
        const start = Math.max(1, Math.min(current - 2, total - 4));
        const end = Math.min(total, start + 4);
        const pages: number[] = [];
        for (let page = start; page <= end; page++) pages.push(page);
        return pages;
    }

    public async setReviewPage(page: number) {
        const total = this.reviewTotalPages();
        const next = Math.min(Math.max(Number(page) || 1, 1), total);
        if (this.reviewPage === next) return;
        this.reviewPage = next;
        if (this.isReviewScope()) {
            await this.load();
            return;
        }
        await this.service.render();
    }

    public resetReviewPagination() {
        this.reviewPage = 1;
    }

    public ensureReviewPage() {
        this.setReviewPage(this.reviewPage);
    }

    public projectDetailPath(project: any, tab: string = '') {
        const id = project && project.id ? project.id : '';
        if (!id) return this.currentListPath();
        return tab === 'review' ? `/projects/${id}/review` : `/projects/${id}`;
    }

    public reviewProject(review: any) {
        return review && review.project ? review.project : {};
    }

    public reviewGroup(review: any) {
        const project = this.reviewProject(review);
        return (review && review.group) || (project && project.group) || {};
    }

    public mergeReviewContext(detail: any, source: any = {}) {
        const project = (detail && detail.project) || (source && source.project) || {};
        const group = (detail && detail.group) || (source && source.group) || (project && project.group) || {};
        return Object.assign({}, source || {}, detail || {}, { project, group });
    }

    public syncReviewInList(review: any) {
        if (!review || !review.id) return;
        const index = this.reviews.findIndex((item) => item && item.id === review.id);
        if (index >= 0) {
            this.reviews[index] = this.mergeReviewContext(review, this.reviews[index]);
            this.calculateReviewStatusCounts();
            this.ensureReviewPage();
            this.scheduleCodexStatusPoll();
        }
    }

    public syncSelectedReviewFromList() {
        if (!this.selectedReview || !this.selectedReview.id) return;
        const review = this.reviews.find((item: any) => item && item.id === this.selectedReview.id);
        if (review) this.selectedReview = this.mergeReviewContext(review, this.selectedReview);
    }

    public resetActivityForm(review: any = this.selectedReview) {
        this.activityForm = {
            message: '',
            status: this.defaultActivityStatus(review)
        };
    }

    public async openReviewDetail(review: any) {
        if (!review || !review.id) return;
        this.selectedReview = review;
        this.reviewDetailLoading = false;
        this.reviewModalTab = 'info';
        this.reviewLogTab = 'navigation';
        this.resetActivityForm(review);
        await this.service.render();
    }

    public async closeReviewDetail() {
        this.selectedReview = null;
        this.reviewDetailLoading = false;
        this.reviewModalTab = 'info';
        this.reviewLogTab = 'navigation';
        this.resetActivityForm(null);
        await this.service.render();
        this.scheduleCodexStatusPoll(true);
    }

    public setReviewModalTab(tab: string) {
        this.reviewModalTab = tab || 'info';
    }

    public async handleReviewModalChange(review: any) {
        if (!review) return;
        this.selectedReview = this.mergeReviewContext(review, this.selectedReview || {});
        this.syncReviewInList(this.selectedReview);
        this.resetActivityForm(this.selectedReview);
        await this.service.render();
    }

    public async removeReviewFromList(review: any) {
        const reviewId = review && review.id ? review.id : '';
        if (!reviewId) return;
        this.reviews = this.reviews.filter((item) => item && item.id !== reviewId);
        this.reviewTotal = Math.max(0, this.reviewTotal - 1);
        this.calculateReviewStatusCounts();
        this.ensureReviewPage();
        if (this.selectedReview && this.selectedReview.id === reviewId) this.closeReviewDetail();
        await this.service.render();
    }

    public async addReviewActivity() {
        if (!this.selectedReview || this.sendingActivity) return;
        const message = String(this.activityForm.message || '').trim();
        if (!message) {
            await this.service.modal.error('작업이력 메시지를 입력해주세요.');
            return;
        }

        const payload: any = { message };
        if (this.selectedReview.can_change_status && this.activityForm.status && this.activityForm.status !== this.selectedReview.status) {
            payload.status = this.activityForm.status;
        }

        this.sendingActivity = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('add_review_activity', {
                review_id: this.selectedReview.id,
                data: JSON.stringify(payload)
            });

            if (code === 200 && data.review) {
                this.selectedReview = this.mergeReviewContext(data.review, this.selectedReview);
                this.syncReviewInList(this.selectedReview);
                this.resetActivityForm(this.selectedReview);
                this.reviewModalTab = 'history';
            } else {
                await this.service.modal.error(data.message || '작업이력을 저장하지 못했습니다.');
            }
        } catch (e) {
            await this.service.modal.error('작업이력을 저장하지 못했습니다.');
        }
        this.sendingActivity = false;
        await this.service.render();
    }

    public rememberProjectReturn(project: any) {
        if (!project || !project.id || !project.group_id) return;
        try {
            sessionStorage.setItem(`reviewops_project_return:${project.id}`, JSON.stringify({
                project_id: project.id,
                group_id: project.group_id,
                path: this.currentListPath(),
                saved_at: new Date().toISOString()
            }));
        } catch (e) { }
    }

    public projectGroupName(project: any) {
        return project && project.group && project.group.name ? project.group.name : '-';
    }

    public reviewGroupName(review: any) {
        const group = this.reviewGroup(review);
        return group && group.name ? group.name : '-';
    }

    public reviewProjectName(review: any) {
        const project = this.reviewProject(review);
        return project && project.name ? project.name : '-';
    }

    public projectTypeValue(project: any) {
        return project && project.project_type ? String(project.project_type) : 'web_service';
    }

    public projectTypeLabel(project: any) {
        return project && project.project_type_label ? project.project_type_label : '웹서비스';
    }

    public labelCandidates(value: any): string[] {
        if (value === null || value === undefined) return [];
        if (Array.isArray(value)) {
            let result: string[] = [];
            for (const item of value) result = result.concat(this.labelCandidates(item));
            return result;
        }
        if (typeof value === 'object') {
            for (const key of ['value', 'label', 'text', 'title', 'name']) {
                if (value[key] !== null && value[key] !== undefined) return this.labelCandidates(value[key]);
            }
            return [];
        }
        const text = String(value).trim();
        if (text.startsWith('[') || text.startsWith('{')) {
            try {
                return this.labelCandidates(JSON.parse(text));
            } catch (e) { }
        }
        return [text];
    }

    public normalizeLabel(value: any) {
        const candidates = this.labelCandidates(value);
        let label = String(candidates.length ? candidates[0] : '').trim().replace(/^#+/, '').trim();
        while (label.indexOf('  ') >= 0) label = label.replace(/  /g, ' ');
        const key = label.toLowerCase();
        if (key === 'object' || key === '[object object]') return '';
        return label.slice(0, 40);
    }

    public normalizeLabels(labels: any) {
        let source = labels;
        if (typeof labels === 'string') {
            const text = labels.trim();
            source = text.startsWith('[') || text.startsWith('{') ? labels : text.replace(/\n/g, ',').split(',');
        }
        const result: string[] = [];
        const seen: any = {};
        for (const value of this.labelCandidates(source)) {
            const label = this.normalizeLabel(value);
            const key = label.toLowerCase();
            if (!label || key === 'object' || key === '[object object]' || seen[key]) continue;
            seen[key] = true;
            result.push(label);
            if (result.length >= 12) break;
        }
        return result;
    }

    public projectLabels(project: any) {
        return this.normalizeLabels(project && project.labels);
    }

    public reviewProjectAdminNames(review: any) {
        const admins = review && review.project && Array.isArray(review.project.project_admins) ? review.project.project_admins : [];
        const names: string[] = [];
        const seen: any = {};
        for (const admin of admins) {
            const name = String((admin && (admin.name || admin.display_name)) || '').trim();
            const keySource = admin && (admin.id || admin.uid || admin.email || admin.user_id || name);
            const key = String(keySource || '').trim().toLowerCase();
            if (!name || seen[key]) continue;
            seen[key] = true;
            names.push(name);
        }
        return names;
    }

    public labelOptions() {
        const labels: string[] = [];
        const seen: any = {};
        for (const project of this.projects) {
            for (const label of this.projectLabels(project)) {
                const value = String(label || '').trim();
                const key = value.toLowerCase();
                if (!value || seen[key]) continue;
                seen[key] = true;
                labels.push(value);
            }
        }
        return labels.sort((a, b) => a.localeCompare(b));
    }

    public filteredLabelOptions() {
        const query = String(this.tagFilterQuery || '').trim().toLowerCase();
        return this.labelOptions().filter((label) => !query || label.toLowerCase().includes(query));
    }

    public openLabelFilter() {
        this.tagFilterOpen = true;
        this.service.render();
    }

    public closeLabelFilterLater() {
        window.setTimeout(async () => {
            this.tagFilterOpen = false;
            await this.service.render();
        }, 120);
    }

    public async selectLabelFilter(label: string) {
        this.filters.label = label || '';
        this.tagFilterQuery = this.filters.label;
        this.tagFilterOpen = false;
        this.resetProjectPagination();
        await this.load();
    }

    public async selectFirstLabelFilter() {
        const options = this.filteredLabelOptions();
        if (options.length) await this.selectLabelFilter(options[0]);
    }

    public async clearLabelFilter() {
        this.filters.label = '';
        this.tagFilterQuery = '';
        this.tagFilterOpen = false;
        this.resetProjectPagination();
        await this.load();
    }

    public statusTabClass(value: string) {
        const selected = this.projectStatusFilter === value;
        const base = 'reviewops-header-control inline-flex h-9 items-center justify-center gap-1.5 border-r border-slate-200 px-3 text-[12px] font-semibold transition-colors last:border-r-0';
        if (selected) return `${base} bg-slate-900 text-white`;
        return `${base} bg-white text-slate-600 hover:bg-slate-50 hover:text-slate-950`;
    }

    public projectTypeFilterTabClass(value: string) {
        const selected = this.projectTypeFilter === value;
        const base = 'inline-flex h-10 items-center justify-center border-b-2 px-3 text-[13px] font-semibold transition-colors';
        if (selected) return `${base} border-slate-950 text-slate-950`;
        return `${base} border-transparent text-slate-500 hover:border-slate-300 hover:text-slate-900`;
    }

    public projectStatusBadgeClass(value: string) {
        const status = value || 'active';
        if (status === 'archived') return 'rounded-full bg-amber-50 px-2 py-0.5 text-[11px] font-medium text-amber-700';
        if (status === 'disabled') return 'rounded-full bg-slate-200 px-2 py-0.5 text-[11px] font-medium text-slate-600';
        return 'rounded-full bg-emerald-50 px-2 py-0.5 text-[11px] font-medium text-emerald-700';
    }

    public isCodexEnabled(project: any) {
        const value = project && project.codex_enabled;
        if (typeof value === 'string') return ['1', 'true', 'yes', 'on'].includes(value.toLowerCase());
        return !!value;
    }

    public codexStatusLabel(project: any) {
        return this.isCodexEnabled(project) ? '활성' : '비활성';
    }

    public codexBadgeClass(project: any) {
        const base = 'whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-medium ';
        if (this.isCodexEnabled(project)) return base + 'bg-emerald-50 text-emerald-700';
        return base + 'bg-slate-100 text-slate-500';
    }

    public reviewStatusBadgeClass(value: string) {
        const status = value || 'open';
        const base = 'inline-flex whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-medium ';
        if (status === 'resolved') return base + 'bg-emerald-50 text-emerald-700';
        if (status === 'closed') return base + 'bg-slate-100 text-slate-700';
        if (status === 'in_review') return base + 'bg-indigo-50 text-indigo-700';
        if (status === 'in_progress') return base + 'bg-amber-50 text-amber-700';
        if (status === 'recheck') return base + 'bg-rose-50 text-rose-700';
        return base + 'bg-rose-50 text-rose-700';
    }

    public activeCodexReviewIds() {
        return (this.reviews || [])
            .filter((review: any) => review && ['queued', 'running'].includes(review.codex_job_status))
            .map((review: any) => review.id)
            .filter((id: string) => !!id);
    }

    public codexReviewIds() {
        return (this.reviews || [])
            .map((review: any) => review && review.id)
            .filter((id: string) => !!id);
    }

    public clearCodexStatusPoll() {
        if (this.codexStatusPollTimer) {
            window.clearTimeout(this.codexStatusPollTimer);
            this.codexStatusPollTimer = null;
        }
    }

    public scheduleCodexStatusPoll(force: boolean = false) {
        this.clearCodexStatusPoll();
        if (this.destroyed || this.workspaceDetached || !this.isReviewScope()) return;
        const reviewIds = this.codexReviewIds();
        if (!reviewIds.length) return;
        if (!force && !this.activeCodexReviewIds().length) return;
        const delay = force ? 0 : this.codexStatusPollIntervalMs;
        this.codexStatusPollTimer = window.setTimeout(() => {
            this.codexStatusPollTimer = null;
            this.refreshCodexReviewStatuses();
        }, delay);
    }

    public async refreshCodexReviewStatuses() {
        if (this.destroyed || this.workspaceDetached || !this.isReviewScope()) return;
        const reviewIds = this.codexReviewIds();
        if (!reviewIds.length) return;
        try {
            const { code, data } = await wiz.call('codex_review_statuses', {
                review_ids: JSON.stringify(reviewIds),
                include_counts: '1'
            });
            if (code === 200 && !this.destroyed && this.isReviewScope()) {
                this.applyCodexReviewStatusData(data || {});
            }
        } catch (e) { }
        if (!this.destroyed && !this.workspaceDetached && this.isReviewScope() && this.activeCodexReviewIds().length) {
            this.scheduleCodexStatusPoll(false);
        }
    }

    public applyCodexReviewStatusData(data: any = {}) {
        const metas = data.metas || {};
        const statuses = data.statuses || {};
        const workCounts = data.work_counts || {};
        let changed = false;
        this.reviews = (this.reviews || []).map((review: any) => {
            if (!review || !review.id) return review;
            const meta = metas[review.id] || {};
            const hasMeta = Object.prototype.hasOwnProperty.call(metas, review.id);
            const nextStatus = hasMeta
                ? String(meta.status || '')
                : (Object.prototype.hasOwnProperty.call(statuses, review.id) ? String(statuses[review.id] || '') : '');
            const nextWorkCount = Object.prototype.hasOwnProperty.call(workCounts, review.id)
                ? this.codexWorkCountValue(workCounts[review.id])
                : this.codexWorkCountValue(review.codex_work_count);
            const nextJobId = nextStatus ? String(meta.job_id || review.codex_job_id || '') : '';
            const nextMessage = nextStatus && Object.prototype.hasOwnProperty.call(meta, 'message')
                ? String(meta.message || '')
                : (nextStatus ? String(review.codex_job_message || '') : '');
            const nextStarted = nextStatus ? String(meta.started || review.codex_job_started || '') : '';
            if (
                String(review.codex_job_status || '') === nextStatus &&
                String(review.codex_job_id || '') === nextJobId &&
                String(review.codex_job_message || '') === nextMessage &&
                String(review.codex_job_started || '') === nextStarted &&
                this.codexWorkCountValue(review.codex_work_count) === nextWorkCount
            ) {
                return review;
            }
            changed = true;
            return Object.assign({}, review, {
                codex_job_status: nextStatus,
                codex_job_id: nextJobId,
                codex_job_message: nextMessage,
                codex_job_started: nextStarted,
                codex_work_count: nextWorkCount
            });
        });
        if (changed) {
            this.calculateReviewStatusCounts();
            this.ensureReviewPage();
            this.syncSelectedReviewFromList();
            this.service.render();
        }
    }

    public codexJobRowStatus(review: any) {
        const status = review && review.codex_job_status;
        return ['running', 'queued'].includes(status) ? status : '';
    }

    public reviewTableRowClass(review: any) {
        const base = 'cursor-pointer align-top transition-colors ';
        const status = this.codexJobRowStatus(review);
        if (status === 'running') return base + 'bg-emerald-50 hover:bg-emerald-100';
        if (status === 'queued') return base + 'bg-slate-100 hover:bg-slate-200';
        return base + 'hover:bg-slate-50/70';
    }

    public codexWorkCountValue(value: any) {
        const count = Number(value || 0);
        if (isNaN(count) || count < 0) return 0;
        return Math.floor(count);
    }

    public codexWorkCount(review: any) {
        return this.codexWorkCountValue(review && review.codex_work_count);
    }

    public codexWorkCountLabel(review: any) {
        return `에이전트 ${this.codexWorkCount(review)}회`;
    }

    public codexWorkCountBadgeClass(review: any) {
        const base = 'inline-flex whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-semibold ';
        if (this.codexWorkCount(review) > 0) return base + 'bg-sky-50 text-sky-700 ring-1 ring-sky-100';
        return base + 'bg-slate-100 text-slate-500 ring-1 ring-slate-200';
    }

    public projectStatusLabel(value: string) {
        const option = this.projectStatusOptions.find((item) => item.value === value);
        return option ? option.label : value;
    }

    public reviewStatusLabel(value: string) {
        const option = this.reviewStatusOptions.find((item) => item.value === value);
        return option ? option.label : value;
    }

    public priorityLabel(value: string) {
        const labels: any = { low: '낮음', normal: '보통', high: '높음', critical: '긴급' };
        return labels[value || 'normal'] || value;
    }

    public categoryLabel(value: string) {
        const labels: any = {
            bug: '버그',
            ux: 'UX',
            content: '콘텐츠',
            performance: '성능',
            accessibility: '접근성',
            security: '보안',
            structure: '구조',
            design: '설계',
            data: '데이터',
            message: '메시지',
            typo: '오탈자',
            other: '기타'
        };
        return labels[value || 'other'] || value;
    }

    public projectStatusEmptyMessage() {
        if (String(this.filters.text || '').trim() || String(this.filters.label || '').trim()) return '검색 결과가 없습니다.';
        return `${this.projectStatusLabel(this.projectStatusFilter)} 프로젝트가 없습니다.`;
    }

    public reviewEmptyMessage() {
        if (this.filters.project_id || this.reviewCategoryFilter) return '검색 결과가 없습니다.';
        if (this.scope().indexOf('task-') === 0 || this.scope() === 'todo') return '작업 리뷰가 없습니다.';
        return '내가 작성한 리뷰가 없습니다.';
    }

    public activityStatusOptions(review: any = this.selectedReview) {
        const allowed = review && Array.isArray(review.allowed_statuses) ? review.allowed_statuses : [];
        return this.reviewStatusOptions.filter((option) => option.value && allowed.includes(option.value));
    }

    public defaultActivityStatus(review: any = this.selectedReview) {
        const options = this.activityStatusOptions(review);
        return options.length ? options[0].value : '';
    }

    public reviewEvidence(review: any = this.selectedReview) {
        return review && review.evidence ? review.evidence : {};
    }

    public reviewIsDocument(review: any = this.selectedReview) {
        const project = this.reviewProject(review);
        const projectType = project && project.project_type ? project.project_type : '';
        const evidence = this.reviewEvidence(review);
        return ['pdf', 'pdf_document', 'pdf_presentation', 'proposal', 'presentation'].includes(projectType) || !!evidence.document_version_id || !!evidence.document_version;
    }

    public documentEvidenceVersion(review: any = this.selectedReview) {
        const evidence = this.reviewEvidence(review);
        return evidence && evidence.document_version ? evidence.document_version : null;
    }

    public documentEvidenceLabel(review: any = this.selectedReview) {
        const version = this.documentEvidenceVersion(review);
        if (!version) return '-';
        const label = version.version_label || this.service.formatter.kstDateTime(version.created, version.created || '-');
        return `${label} · ${version.file_name || '-'}`;
    }

    public reviewScaleLabel(value: any) {
        const scale = Number(value || 0);
        if (!scale) return '-';
        return `${scale.toFixed(2).replace(/\.?0+$/, '')}x`;
    }

    public captureLabel(value: string) {
        const labels: any = {
            sdk_capture: 'SDK 캡처',
            browser_capture: '브라우저 캡처',
            screen_share: '화면 공유',
            manual_upload: '직접 첨부',
            'review-create-screenshot-skipped': '캡처 안함',
            not_available: '캡처 없음'
        };
        return labels[value || 'not_available'] || value || '캡처 없음';
    }

    public evidenceCount(review: any, key: string) {
        const value = this.reviewEvidence(review)[key];
        return Array.isArray(value) ? value.length : 0;
    }

    public evidenceEntries(review: any, key: string) {
        const value = this.reviewEvidence(review)[key];
        return Array.isArray(value) ? value : [];
    }

    public reviewLogTabItem(tab: string = this.reviewLogTab) {
        return this.reviewLogTabs.find((item) => item.key === tab) || this.reviewLogTabs[0];
    }

    public reviewLogEntries(tab: string = this.reviewLogTab) {
        const item = this.reviewLogTabItem(tab);
        return this.evidenceEntries(this.selectedReview, item.field);
    }

    public reviewLogCount(tab: string) {
        const item = this.reviewLogTabItem(tab);
        return this.evidenceCount(this.selectedReview, item.field);
    }

    public logEntryTitle(item: any) {
        if (!item) return '-';
        return item.title || item.url || item.text || item.message || item.selector || item.event || item.type || item.source || '로그';
    }

    public logEntryMeta(item: any) {
        if (!item) return '';
        const parts = [
            item.method,
            item.status,
            item.status_text,
            item.resource_type,
            item.level,
            item.at || item.created || item.time
        ].filter((value) => value !== null && value !== undefined && String(value).trim());
        return parts.join(' · ');
    }

    public logEntryBody(item: any) {
        if (!item) return '';
        try {
            return JSON.stringify(item, null, 2);
        } catch (e) {
            return String(item || '');
        }
    }

    public activityStatusText(item: any) {
        if (!item || !item.status) return '댓글';
        return `상태 변경 · ${this.reviewStatusLabel(item.status)}`;
    }

    public kstDateTime(value: any) {
        return this.service.formatter.kstDateTime(value, '-');
    }

    public reviewSummaryCount(summary: any, status: string) {
        if (status === 'total') return Number(summary && summary.total) || 0;
        const byStatus = summary && summary.by_status ? summary.by_status : {};
        return Number(byStatus && byStatus[status]) || 0;
    }

    public reviewSummaryTileClass(summary: any, status: string, activeBg: string, extra: string = '') {
        const base = `${extra ? `${extra} ` : ''}rounded-md px-1.5 py-1.5`;
        return `${base} ${this.reviewSummaryCount(summary, status) > 0 ? activeBg : 'bg-slate-50'}`;
    }

    public reviewSummaryLabelClass(summary: any, status: string, activeText: string, size: string = 'text-[10px]') {
        return `${size} ${this.reviewSummaryCount(summary, status) > 0 ? activeText : 'text-slate-300'}`;
    }

    public reviewSummaryCountClass(summary: any, status: string, activeText: string) {
        return `text-[13px] font-semibold ${this.reviewSummaryCount(summary, status) > 0 ? activeText : 'text-slate-300'}`;
    }

    public projectDocumentVersionLabel(project: any) {
        const version = project && project.current_document_version ? project.current_document_version : null;
        const value = version && (version.version_label || version.created);
        return this.service.formatter.kstDateTime(value, value || '-');
    }

    public projectTargetLabel(project: any) {
        if (project && project.is_document_project && project.current_document_version) {
            return `${project.current_document_version.file_name} · ${this.projectDocumentVersionLabel(project)}`;
        }
        return project && project.link_url ? project.link_url : '-';
    }
}

export default PageReviewsComponent;